<template>
    <div id="contnet" class="minHeight">
        <micro-class-screen v-bind:fromIndexRes="fromIndexResouresData" @subjectIdIndex="subjectIdIndex" :isMicroClass="isMicroClass"></micro-class-screen>
        <micro-class-list @showPlayer="showPlayer" :subjectIdIndexLeft="subjectIdIndexLeft"></micro-class-list>
        <video-player v-if="isPlayer" @closePlayer="closePlayer"></video-player>

    </div>

</template>
<script>
import MicroClassScreen from '../MicroClassScreen/MicroClassScreen.vue'
import MicroClassList from '../MicroClassList/MicroClassList.vue'
import VideoPlayer from '../videoPlayer/viderPlayer.vue'
export default {
    name:'MicroClass',
    props:{
      fromIndexResouresData:{
        type:Object,
        default:{'isFromIndexSyn':null,'sujectId':80,'routerMicroName':null}
      }
    },
    data(){
        return{
            isPlayer:false,
            subjectIdIndexLeft:null,
            isMicroClass:true
        }
    },
    methods:{
        showPlayer(obj){
            this.isPlayer = obj;            //打开播放器  ture
        },
        closePlayer(obj){
            this.isPlayer = obj;            //关闭播放器 false
        },
        subjectIdIndex(msg){
          this.subjectIdIndexLeft = msg
        }
    },
    components:{
        MicroClassScreen,MicroClassList,VideoPlayer
    }
}
</script>



// WEBPACK FOOTER //
// src/components/MicroClass/MicroClass.vue